import { useQuery } from '@tanstack/react-query';
import type { ApiList, AuditLogListQuery, AuditLogRow } from '@app/shared';
import { apiClient } from '../../lib/api-client';

export function useAuditLogs(query: Partial<AuditLogListQuery> = {}) {
  return useQuery({
    queryKey: ['audit-logs', query],
    queryFn: async (): Promise<ApiList<AuditLogRow>> => {
      const res = await apiClient.get<ApiList<AuditLogRow>>('/audit-logs', { params: query });
      return res.data;
    },
  });
}
